import React, { useState, useEffect, useRef } from 'react';
import ChatModal from './ChatModal'; // <-- Импортируем модалку

// -------------------------------------------------------------
// ИМПОРТ ИКОНОК ИЗ ПАПКИ ASSETS
// -------------------------------------------------------------
import iconMessage from './assets/icon-message.png';

const NotificationsDropdown = () => {
  const [dialogs, setDialogs] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [unreadTotal, setUnreadTotal] = useState(0);
  
  // Стейт для открытого чата
  const [activeChat, setActiveChat] = useState(null); 

  const dropdownRef = useRef(null);

  const fetchDialogs = async () => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch('/api/messages/dialogs/', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setDialogs(data);
        const total = data.reduce((acc, curr) => acc + (curr.unread_count || 0), 0);
        setUnreadTotal(total);
      }
    } catch (err) {
      console.error('Ошибка загрузки сообщений:', err);
    }
  };

  useEffect(() => {
    fetchDialogs();
    const interval = setInterval(fetchDialogs, 15000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>
        {/* КНОПКА СООБЩЕНИЙ В СТИЛЕ LIQUID GLASS */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-sm bg-slate-900/40 backdrop-blur-md border border-white/10 text-slate-200 px-4 py-2.5 rounded-2xl hover:bg-slate-800/60 hover:border-white/20 shadow-[inset_0_1px_1px_rgba(255,255,255,0.15),0_8px_20px_rgba(0,0,0,0.3)] transition-all duration-300 active:scale-95 cursor-pointer flex items-center justify-center gap-2"
        >
          {/* ИКОНКА СООБЩЕНИЙ */}
          <img 
            src={iconMessage} 
            alt="Сообщения" 
            className="w-8 h-8 object-contain drop-shadow-md" 
          />
          {unreadTotal > 0 && (
            <span className="bg-rose-500/90 backdrop-blur-sm border border-rose-300/30 text-white rounded-full px-2 py-0.5 text-xs font-bold shadow-[inset_0_1px_1px_rgba(255,255,255,0.4)]">
              {unreadTotal}
            </span>
          )}
        </button>

        {/* ВЫПАДАЮЩИЙ СПИСОК В СТИЛЕ СТЕКЛА */}
        {isOpen && (
          <div className="absolute right-0 top-14 w-80 bg-slate-900/80 backdrop-blur-2xl border border-white/15 rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] z-50 overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            <div className="p-4 border-b border-white/10 font-bold text-white text-sm bg-white/5 backdrop-blur-md flex items-center justify-between">
              <span>Сообщения и диалоги</span>
              {unreadTotal > 0 && (
                <span className="text-xs text-indigo-300 font-normal">
                  {unreadTotal} непр.
                </span>
              )}
            </div>

            <div className="max-h-80 overflow-y-auto divide-y divide-white/5">
              {dialogs.length === 0 ? (
                <div className="p-6 text-center text-xs text-slate-400">
                  У вас пока нет активных диалогов
                </div>
              ) : (
                dialogs.map((dialog) => (
                  <div
                    key={dialog.user_id}
                    className="p-3.5 hover:bg-white/10 cursor-pointer transition duration-200"
                    onClick={() => {
                      setActiveChat({ id: dialog.user_id, name: dialog.username });
                      setIsOpen(false);
                    }}
                  >
                    <div className="flex justify-between items-center mb-1">
                      <span className="font-semibold text-indigo-300 text-sm">{dialog.username}</span>
                      {dialog.unread_count > 0 && (
                        <span className="bg-rose-500/90 text-white text-[10px] px-2 py-0.5 rounded-full font-bold shadow-sm">
                          +{dialog.unread_count}
                        </span>
                      )}
                    </div>
                    <div className="text-xs text-slate-300 truncate">
                      {dialog.last_message || 'Нет сообщений'}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>

      {/* Окно чата */}
      {activeChat && (
        <ChatModal
          recipientId={activeChat.id}
          recipientName={activeChat.name}
          onClose={() => {
            setActiveChat(null);
            fetchDialogs(); // Обновляем список диалогов после закрытия
          }}
        />
      )}
    </>
  );
};

export default NotificationsDropdown;